import { breakpoints } from '../breakpoints';
import { Breakpoints, MediaQuery } from '../media-query.types';

export function getBreakpointStart(breakpointValue: Breakpoints) {
    if (breakpoints[breakpointValue].size) {
        return breakpoints[breakpointValue].size;
    } else {
        console.error('No valid breakpoint or size specified for media.');
        return 0;
    }
}

export function getBreakpointEnd(breakpointValue: Breakpoints) {
    const value = breakpoints[breakpointValue].next;

    if (value) return value;
    else {
        console.error('No valid breakpoint or size specified for media.');
        return 0;
    }
}

export function getMediaQueries(): MediaQuery[] {
    const breakpointMap = Object.keys(breakpoints);

    return breakpointMap.map((item: any, index: number) => {
        const breakpoint = breakpoints[item as Breakpoints];
        const breakpointAbove = breakpoints[breakpointMap[index + 1] as Breakpoints];

        return {
            breakpoint: item,
            query: () => {
                if (index === 0) {
                    return `(max-width: ${toEm(breakpointAbove.size - 1)})`;
                } else if (index === breakpointMap.length - 1) {
                    return `(min-width: ${toEm(breakpoint.size)})`;
                } else {
                    return `(max-width: ${toEm(breakpointAbove.size - 1)}) and (min-width: ${toEm(
                        breakpoint.size,
                    )})`;
                }
            },
        };
    });
}

export const toEm = (value: number) => `${value / 16}em`;
